import Menu from "../Menu/Menu.component";

export default function Layout({ children, title }) {
    return (
        <section className="flex flex-col w-full px-8 md:pl-28 md:pr-10">
            <Menu title={title}/>
            {children}
        </section>
    )
}